import * as types from 'constants/actionTypes';
import initialState from './initialState';

export default function cubsReducer(
  state = initialState.referenceData.cubs,
  action
) {
  if (action.type === types.GET_CUBS_SUCCESS) {
    return [...action.cubs];
  }
  return state;
}